export class Schedule {
    public job_is_separated: any = 0;
    constructor(
        public jobId: any,
        public agent_id: any,
        public from_date: any,
        public to_date: any,
        public inspection_time: string,
        public job_time_scheduled: string,
        public from_time: any,
        public to_time: any,
        public calculated_time: number,
        public job_fee: any,
        public job_fee_discount: any,
        public job_fee_discount_type: any,
        public job_payment_type: any,
        public job_payment_type_notes: any,
        public job_escrow_number: any,
        public job_escrow_closing_date: any,
        public job_confirmation_email_sent: any,
        public job_is_requested: any,
        public add_to_calendar: any,
        public add_to_office_calendar: any,
        public job_cc_number: any,
        public job_cc_exp_month: any,
        public job_cc_exp_year: any,
        public job_cc_vcode: any,
        public wants_earlier: any,
        public client_id: any,
        public selected_card: any,
        public charge_card: any,
        public charge_card_inspection: any,

        public additional_email: any,
        public client_email: any,
        public anytime: any,
        public job_fees: any,
    ) { }

}